import axios from "axios";
import API_BASE_URL from "../config/baseUrl";
import { getAccessToken } from "../store/actions/auth";

// Update Limit API function
export const updateLimit = async function (userId, limit, limitPlus) {
  try {
    const token = getAccessToken();

    if (!token) {
      return { success: false, error: "No access token found" };
    }

    const response = await axios.post(
      API_BASE_URL + "/user/update-limit",
      {
        userId: userId,
        limit: limit,
        limitInCash: false,
        limitPlus: limitPlus,
      },
      {
        headers: { Authorization: "Bearer " + token },
      },
    );

    const data = response.data;

    if (data.status === false) {
      return {
        success: false,
        error: data.message || "Failed to update limit",
      };
    }

    return { success: true, message: data.message };
  } catch (err) {
    const errorMessage =
      err.response?.data?.message || "Failed to update limit";
    return { success: false, error: errorMessage };
  }
};

// Activate/Deactivate User API function
export const activateDeactivateUser = async function (userId, activate) {
  try {
    const token = getAccessToken();

    if (!token) {
      return { success: false, error: "No access token found" };
    }

    const response = await axios.post(
      API_BASE_URL + "/user/activate-deactivate-user",
      {
        activate: activate,
        userIdList: [userId],
      },
      {
        headers: { Authorization: "Bearer " + token },
      },
    );

    const data = response.data;

    if (data.status === false) {
      return {
        success: false,
        error: data.message || "Failed to update user status",
      };
    }

    return { success: true, message: data.message };
  } catch (err) {
    const errorMessage =
      err.response?.data?.message || "Failed to update user status";
    return { success: false, error: errorMessage };
  }
};

// Bet Lock API function
export const toggleBetLockApi = async function (userId, isLock) {
  try {
    const token = getAccessToken();

    if (!token) {
      return { success: false, error: "No access token found" };
    }

    const response = await axios.post(
      API_BASE_URL + "/ant-pro/bet-lock",
      {
        userId: userId,
        isLock: isLock,
      },
      {
        headers: { Authorization: "Bearer " + token },
      },
    );

    const data = response.data;

    if (data.status === false) {
      return {
        success: false,
        error: data.message || "Failed to update bet lock status",
      };
    }

    return { success: true, message: data.message };
  } catch (err) {
    const errorMessage =
      err.response?.data?.message || "Failed to update bet lock status";
    return { success: false, error: errorMessage };
  }
};

// Casino Bet Lock API function
export const toggleCasinoLockApi = async function (userId, isLock) {
  try {
    const token = getAccessToken();

    if (!token) {
      return { success: false, error: "No access token found" };
    }

    const response = await axios.post(
      API_BASE_URL + "/ant-pro/casino-bet-lock",
      {
        userId: userId,
        isLock: isLock,
      },
      {
        headers: { Authorization: "Bearer " + token },
      },
    );

    const data = response.data;

    if (data.status === false) {
      return {
        success: false,
        error: data.message || "Failed to update casino lock status",
      };
    }

    return { success: true, message: data.message };
  } catch (err) {
    const errorMessage =
      err.response?.data?.message || "Failed to update casino lock status";
    return { success: false, error: errorMessage };
  }
};

// Search Users API function
export const searchUsersApi = async function (userType, searchTerm) {
  try {
    const token = getAccessToken();

    if (!token) {
      return { success: false, error: "No access token found" };
    }

    const response = await axios.post(
      API_BASE_URL + "/user/list-user-v2",
      {
        userType: String(userType),
        parentId: "",
        noOfRecords: 25,
        index: 0,
        userToSearch: searchTerm,
        forDeadClient: false,
      },
      {
        headers: { Authorization: "Bearer " + token },
      },
    );

    const data = response.data;

    if (data.status === false) {
      return {
        success: false,
        error: data.message || "Failed to search users",
      };
    }

    return { success: true, data: data.data };
  } catch (err) {
    const errorMessage =
      err.response?.data?.message || "Failed to search users";
    return { success: false, error: errorMessage };
  }
};

// Update Betting Status API function
// type: "all" | "fancy" | "bookmaker" | "casino"
export const updateBettingStatusApi = async function (userId, blocked, type = "all", cascade = true) {
  try {
    const token = getAccessToken();

    if (!token) {
      return { success: false, error: "No access token found" };
    }

    const response = await axios.patch(
      `${API_BASE_URL}/api/users/${userId}/betting-status?cascade=${cascade}`,
      {
        blocked: blocked,
        type: type,
      },
      {
        headers: { Authorization: "Bearer " + token },
      },
    );

    const data = response.data;

    if (data.status === false) {
      return {
        success: false,
        error: data.message || "Failed to update betting status",
      };
    }

    return { success: true, message: data.message || "Betting status updated successfully" };
  } catch (err) {
    const errorMessage =
      err.response?.data?.message || "Failed to update betting status";
    return { success: false, error: errorMessage };
  }
};

// Get Betting Status API function
export const getBettingStatusApi = async function (userId) {
  try {
    const token = getAccessToken();

    if (!token) {
      return { success: false, error: "No access token found" };
    }

    const response = await axios.get(
      `${API_BASE_URL}/api/users/${userId}/betting-status`,
      {
        headers: { Authorization: "Bearer " + token },
      },
    );

    const data = response.data;

    if (data.status === false) {
      return {
        success: false,
        error: data.message || "Failed to get betting status",
      };
    }

    return { 
      success: true, 
      data: data.data || data,
    };
  } catch (err) {
    const errorMessage =
      err.response?.data?.message || "Failed to get betting status";
    return { success: false, error: errorMessage };
  }
};
